export default "__VITE_ASSET__DmPgeEJ8__"